export default [
  {
    title: 'Catálogo',
    route: 'home',
    icon: 'HomeIcon',
    action: 'read',
    resource: 'Home',
    explicitModule: true,
  },
];
